import React from "react";
import constants from "config/constants";
import "../styles/PrivacyPolicy.css";

function PrivacyPolicy() {
  return (
    <div className="privacy-policy-container">
      {/* Header Section */}
      <div className="header-container">
        <h1 className="privacy-policy-container">PRIVACY POLICY</h1>
      </div>
      <div className="privacy-policy-main-view">
        <div>
          <h2>
            <span className="company-name">Hua Shen Herbs</span>
          </h2>
          <p className="effective-date">Effective Date: April 4, 2026</p>
        </div>

        {/* Introduction */}
        <p>
          <span className="company-name">Hua Shen Herbs</span> ("we," "us," or
          "our") is committed to protecting your privacy and safeguarding your
          personal information. This Privacy Policy explains how we collect,
          use, and protect your information when you visit our website, complete
          forms, or purchase products or services.
        </p>

        {/* Information We Collect */}
        <div className="privacy-policy-section">
          <h2>INFORMATION WE COLLECT</h2>
          <p>We may collect the following types of information:</p>

          <h3
            style={{
              fontSize: "var(--font-size-body)",
              marginTop: "var(--spacing-lg)",
              marginBottom: "var(--spacing-md)",
              fontWeight: "var(--font-weight-semibold)",
              color: "var(--color-primary-light)",
              borderBottom: "1px solid var(--color-border)",
              paddingBottom: "var(--spacing-sm)",
            }}
          >
            Personal Information
          </h3>
          <ul>
            <li>Name</li>
            <li>Email address</li>
            <li>Phone number</li>
            <li>Billing and shipping address</li>
          </ul>

          <h3
            style={{
              fontSize: "var(--font-size-body)",
              marginTop: "var(--spacing-lg)",
              marginBottom: "var(--spacing-md)",
              fontWeight: "var(--font-weight-semibold)",
              color: "var(--color-primary-light)",
              borderBottom: "1px solid var(--color-border)",
              paddingBottom: "var(--spacing-sm)",
            }}
          >
            Health Information
          </h3>
          <ul>
            <li>Medical history</li>
            <li>Medications and supplements</li>
            <li>Allergies and sensitivities</li>
            <li>Wellness concerns shared during intake or consultation</li>
          </ul>

          <h3
            style={{
              fontSize: "var(--font-size-body)",
              marginTop: "var(--spacing-lg)",
              marginBottom: "var(--spacing-md)",
              fontWeight: "var(--font-weight-semibold)",
              color: "var(--color-primary-light)",
              borderBottom: "1px solid var(--color-border)",
              paddingBottom: "var(--spacing-sm)",
            }}
          >
            Payment Information
          </h3>
          <p>
            Payment details are processed securely through third-party payment
            processors. We do not store full payment card information.
          </p>
        </div>

        {/* How We Use Your Information */}
        <div className="privacy-policy-section">
          <h2>HOW WE USE YOUR INFORMATION</h2>
          <p>We use your information to:</p>
          <ul>
            <li>Provide consultations and customized herbal formulations</li>
            <li>
              Communicate with you regarding appointments, orders, and follow-up
              care
            </li>
            <li>Process payments and fulfill orders</li>
            <li>Improve our services and client experience</li>
          </ul>
          <p>
            <strong>
              We do not sell, rent, or trade your personal information.
            </strong>
          </p>
        </div>

        {/* Health Information and Confidentiality */}
        <div className="privacy-policy-section">
          <h2>HEALTH INFORMATION AND CONFIDENTIALITY</h2>
          <p>
            We take reasonable steps to protect your health-related information
            and maintain confidentiality.
          </p>
          <p>
            <strong>Please note:</strong>
          </p>
          <ul>
            <li>Services provided are not hospital-based care</li>
            <li>
              While we follow privacy-conscious practices, our services may not
              be subject to all provisions of the Health Insurance Portability
              and Accountability Act (HIPAA)
            </li>
            <li>
              By using our services, you acknowledge and accept these
              limitations
            </li>
          </ul>
        </div>

        {/* Sharing of Information */}
        <div className="privacy-policy-section">
          <h2>SHARING OF INFORMATION</h2>
          <p>We may share your information only when necessary with:</p>
          <ul>
            <li>Payment processors (for secure transactions)</li>
            <li>Shipping providers (to deliver products)</li>
            <li>
              Technology platforms used for scheduling, communication, or
              record-keeping
            </li>
          </ul>
          <p>
            These providers are expected to maintain appropriate data protection
            standards.
          </p>
        </div>

        {/* Data Security */}
        <div className="privacy-policy-section">
          <h2>DATA SECURITY</h2>
          <p>
            We implement reasonable administrative, technical, and physical
            safeguards to protect your information. However, no method of
            transmission over the internet is completely secure.
          </p>
        </div>

        {/* Your Rights */}
        <div className="privacy-policy-section">
          <h2>YOUR RIGHTS</h2>
          <p>You may:</p>
          <ul>
            <li>Request access to your personal information</li>
            <li>Request corrections to inaccurate information</li>
            <li>Request that we delete your information, where applicable</li>
          </ul>
          <p>To make a request, contact us using the information below.</p>
        </div>

        {/* Cookies and Website Data */}
        <div className="privacy-policy-section">
          <h2>COOKIES AND WEBSITE DATA</h2>
          <p>
            Our website may use cookies or similar technologies to enhance user
            experience and analyze site usage. You can adjust your browser
            settings to disable cookies if preferred.
          </p>
        </div>

        {/* Third-Party Links */}
        <div className="privacy-policy-section">
          <h2>THIRD-PARTY LINKS</h2>
          <p>
            Our website may contain links to third-party websites. We are not
            responsible for the privacy practices of those websites.
          </p>
        </div>

        {/* Changes to This Policy */}
        <div className="privacy-policy-section">
          <h2>CHANGES TO THIS POLICY</h2>
          <p>
            We may update this Privacy Policy from time to time. Updates will be
            posted on this page with a revised effective date.
          </p>
        </div>

        {/* Contact Section */}
        <div className="privacy-policy-footer">
          <h2>CONTACT</h2>
          <div className="privacy-policy-contact">
            <strong>{"Hua Shen Herbs"}</strong>
            <br />
            {constants?.contact?.emailAddress}
            <br />
            <strong>{constants?.contact?.officeAddress}</strong>
          </div>
        </div>
      </div>
      {/* Agreement Statement */}
      <div className="privacy-policy-agreement">
        <p>
          By using this website and our services, you acknowledge that you have
          read and agree to this Privacy Policy.
        </p>
      </div>
    </div>
  );
}

export default PrivacyPolicy;
